// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__WA65C","verticalIcon":"styles_verticalIcon__3mITx"};